import { setComponentMapOverrides } from '@jutro/legacy/uiconfig';
import PolicyChangesPage from './pages/PolicyChanges/PolicyChangesPage';
import QuotePage from './pages/Quote/QuotePage' // './pages/Quote/QuotePage';
import ConfirmationPage from './pages/Confirmation/ConfirmationPage';
// import CodegenWizard from './CodegenWizard';
// import { CodegenContext } from './components/CodegenContext';

setComponentMapOverrides(
    {
        PremierPolicyChangesPage: { component: 'PremierPolicyChangesPage' },
        PremierQuotePage: { component: 'PremierQuotePage' },
        PremierConfirmationPage: { component: 'PremierConfirmationPage' }
    },
    {
        PremierPolicyChangesPage: PolicyChangesPage,
        PremierQuotePage: QuotePage,
        PremierConfirmationPage: ConfirmationPage
    }
);

export { default as messages } from './PolicyChangeCommon.messages';
